<template>
  <div class="ErrorPage">
    <h1>{{ msg }}<a @click="back">返回</a></h1>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  data () {
    return {
      msg: '404  页面不存在'
    }
  },
  methods: {
    // back
    back(){
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  h1 {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    user-select: none;
    font-size: 40px;

    a {
      font-size: 20px;
      margin-left: 10px;

      &:hover {
        text-decoration: underline;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/error/errorPage.vue